import colors from "../../_colors.scss";

// Categorical Early Warning levels, ordered from most severe to least.
// "no data" is always last so it renders at the bottom of the legend.
export const EWS_WARNING_LEVELS = Object.freeze([
	"severe warning",
	"warning",
	"watch",
	"no warning",
	"positive",
	"no data",
]);

// Color associated with each warning level. We reuse the existing risk palette
// from MagnetMap for visual consistency across the dashboard.
export const EWS_WARNING_COLOR_MAP = Object.freeze({
	"severe warning": colors.riskVeryHigh, // red
	"warning": colors.riskHigh, // orange-red
	"watch": colors.riskMedium, // orange
	"no warning": colors.riskLow, // light green
	"positive": colors.riskVeryLow, // green
	"no data": colors.greyDark,
});

// Derive an Early Warning level from the percentage yield change (pct_change).
// Thresholds are intentionally centralized here so they are trivial to tune.
//   <= -15% : severe warning
//   <=  -5% : warning
//    <   0% : watch
//   ==   0% : no warning
//    >   0% : positive
export const getEwsWarningLevel = (pctChange) => {
	if (pctChange == null || pctChange === "nan" || Number.isNaN(Number(pctChange))) {
		return "no data";
	}

	const v = Number(pctChange);
	if (v <= -15) return "severe warning";
	if (v <= -5) return "warning";
	if (v < 0) return "watch";
	if (v === 0) return "no warning";
	return "positive";
};
